import { useState, useEffect } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import { toast } from "react-hot-toast";

const ForgetPasswordService = () => {
  const [input, setInput] = useState({});
  const [location, setLocation] = useState({ latitude: "", longitude: "" });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          toast.error("Location access denied. Using default location.");
        }
      );
    } else {
      toast.error("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const bodyObject = {
        LoginTypeID: 1,
        UserID: input?.UserID,
        Longitude: location?.longitude,
        Latitude: location?.latitude,
      };

      const res = await ApiCalling.request(
        "POST",
        "/ForgetPassword",
        bodyObject,
        null
      );
      if (res?.statuscode === 1) {
        toast.success(res?.msg);
      } else {
        toast.error(res?.msg, { toastId: "forgetPsw error" });
      }
    } catch (error) {
      console.error("Error forgetPsw in:", error);
    }
  };

  return { input, handleChange, handleSubmit };
};

export default ForgetPasswordService;
